module.exports = __webpack_public_path__ + "static/media/IMG_20190826_165739.thumbnail.b0e2eb0c.png";